import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

/**
 * Sidebar groups, by operational topic.
 *
 * The portal used to render thirteen modules as one flat list at mixed
 * altitudes: a one-page audit log sat next to a six-tab account hub, and
 * "Billing" and "Pricing" were two entries for one job. Grouping is what makes
 * a thirteen-item nav readable inside a phone drawer, and it is also how a new
 * module finds its home without a discussion.
 */
export type NavGroup = "overview" | "customers" | "revenue" | "services" | "operations";

export const NAV_GROUPS: { key: NavGroup; label: string }[] = [
  { key: "overview", label: "" },
  { key: "customers", label: "Customers" },
  { key: "revenue", label: "Revenue" },
  { key: "services", label: "Platform services" },
  { key: "operations", label: "Operations" },
];

export type ModuleRoute = {
  path: string;
  element: ReactNode;
  /** When set, shows up in the module's sub-nav. Omit for hidden routes (e.g. ":id"). */
  label?: string;
  /**
   * Gate this route on its own permission.
   *
   * Needed once Billing and Pricing merged into one Revenue module: the two
   * halves are governed by different abilities (`subscription.read` vs
   * `plans.manage`), so the gate had to move from the module down to the route.
   */
  requiredPermission?: string;
};

export type AdminModule = {
  key: string;
  label: string;
  /** One line for the Overview page's module grid. Say what the module is for. */
  description?: string;
  group: NavGroup;
  icon: LucideIcon;
  requiredPermission?: string;
  routes: ModuleRoute[];
};
